<script>
import ApiService from "../utils/ApiService";

export default {
    name: "DialogEditRole",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        roleId: {
            type: Number || String,
            default: 0
        }
    },
    data() {
        return {
            visible: this.value,
            role: {
                id: 0,
                name: '',
                identifier: '',
                permissions: []
            },
            menus: [],
            grantAll: false
        }
    },
    watch: {
        value(val) {
            this.visible = val;
        },
        roleId(val) {
            if (val) {
                ApiService.get('/users/roles/' + val).then(response => {
                    this.role = {
                        ...this.role,
                        ...response.data
                    }
                    this.grantAll = this.role.permissions.includes('*');
                });
            }
        }
    },
    methods: {
        onSubmit() {
            let {role} = this;
            if (!role.name) {
                this.$showToast(this.$t('Role name required'));
                return false;
            }

            if (this.grantAll) {
                role.permissions = ['*'];
            } else {
                role.permissions = role.permissions.filter(item => item !== '*');
            }

            if (role.id) {
                ApiService.put('/users/roles/' + role.id, role).then(() => {
                    this.$emit('input', false);
                    this.$message.success(this.$t('Role Saved'));
                }).catch(reason => {
                    this.$message.error(reason.message);
                }).finally(() => {

                });
            } else {
                ApiService.post('/users/roles', role).then(() => {
                    this.$emit('update:value', false);
                    this.$message.success(this.$t('Role Saved'));
                }).catch(reason => {
                    this.$message.error(reason.message);
                }).finally(() => {

                });
            }
        },
        fetchMenus() {
            ApiService.get('/adminmenus').then(response => {
                this.menus = response.data;
            }).catch(reason => {
                this.$message.error(reason.message);
            });
        }
    },
    mounted() {
        this.fetchMenus();
    }
}
</script>

<template>
    <el-dialog
        :title="role.id ? $t('Edit Role') : $t('Add Role')"
        closeable
        width="75%"
        :visible.sync="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="$emit('input', false)"
    >
        <el-form label-width="120px" size="medium">
            <el-form-item :label="$t('Name')">
                <el-input class="w300" v-model="role.name"/>
            </el-form-item>
            <el-form-item :label="$t('Identifier')">
                <el-input class="w300" :disabled="role.identifier==='administrator'" v-model="role.identifier"/>
            </el-form-item>
            <el-form-item :label="$t('Permissions')">
                <el-checkbox v-model="grantAll">
                    <strong>Grant all permissions</strong>
                </el-checkbox>
                <el-checkbox-group v-model="role.permissions" v-if="!grantAll">
                    <div v-for="(item, index) in menus" :key="index">
                        <div>
                            <el-checkbox :label="item.name">
                                <strong>{{ item.title }}</strong>
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;">
                            <el-checkbox v-for="(menu, idx) in item.menus" :key="menu.name" :label="menu.name">
                                {{ menu.title }}
                            </el-checkbox>
                        </div>
                    </div>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="medium" class="w100" @click="onSubmit">
                    {{ $t('common.submit') }}
                </el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<style scoped>

</style>